










import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { State } from 'vuex-class'

import JobEmploymentPositionHelperComponents2Header from './job-employment-position-helper-components-2-header.vue'
import JobEmploymentPositionHelperComponents3ResourceList from './job-employment-position-helper-components-3-resource-list.vue'

// const namespace = 'digitalCurrency'

@Component({
  components: {
    JobEmploymentPositionHelperComponents2Header,
    JobEmploymentPositionHelperComponents3ResourceList
  }
})
class JobEmploymentPositionHelperComponents1MainPage extends Vue {
  @State('isMobileDevice') isMobileDevice?: boolean

  @Prop({ default: '' }) productResourceId?: string
  @Prop({ default: false }) showInNav?: boolean


  emitToggleShowContent ({ contentName, isVisible }: { contentName: string, isVisible?: boolean}) {
    this.$emit('toggleShowContent', { contentName, isVisible })
  }
}

export default JobEmploymentPositionHelperComponents1MainPage
